module.exports = __webpack_public_path__ + "static/img/12.398634e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/12.png
// module id = TNPK
// module chunks = 0